import React from "react";
import RunTabContent, { type RunTabBaseProps } from "./RunTabContent";

const DeletedRunsTab: React.FC<RunTabBaseProps> = (props) => {
  return <RunTabContent {...props} tabIndex={2} />;
};

export default DeletedRunsTab;
